import { toast } from 'react-toastify';
import * as API from '../API/api.js';
import {
  NEWSLETTER_DELETE,
  NEWSLETTER_REQUEST,
  NEWSLETTER_FAILURE,
  NEWSLETTER_SUCCESS,
} from '../Constants/ActionTypes.js';
import { UPLOAD_FILE_USER_REQUEST, UPLOAD_FILE_USER_SUCCESS, UPLOAD_FILE_USER_FAILURE } from '../Constants/ActionTypes';

export const newsletterDetails = (values, token) => async dispatch => {
  try {
    console.log(values);
    dispatch({ type: NEWSLETTER_REQUEST });
    const data = await API.postNewsletter(values, token);
    if (data) {
      dispatch({ type: NEWSLETTER_SUCCESS, payload: data });
      // navigate('/')
      toast('Newsletter Added Successfully');
    }
  } catch (error) {
    console.log(error);
    toast('DATA NOT DISPATCHED');
    dispatch({ type: NEWSLETTER_FAILURE });
  }
};

export const newsletterUploadFile = values => async dispatch => {
  try {
    dispatch({ type: UPLOAD_FILE_USER_REQUEST });
    const data = await API.fileUpload(values);
    // console.log(data)
    if (data.data.success === true) {
      toast('FILE UPLOADED SUCCESSFULLY');
      dispatch({ type: UPLOAD_FILE_USER_SUCCESS, payload: data.data.url });
      // navigate('/')
    }
  } catch (error) {
    // console.log(error)
    toast('PLEASE UPLOAD YOUR FILE AGAIN');
    dispatch({ type: UPLOAD_FILE_USER_FAILURE });
  }
};

export const deleteNewsletter = (values, token) => async dispatch => {
  try {
    console.log(values);
    dispatch({ type: NEWSLETTER_DELETE });
    const data = await API.deleteNewsletter(values, token);
    console.log(data);
    if (data) {
      dispatch({ type: NEWSLETTER_DELETE, payload: data });
      // navigate('/')
      toast('Newsletter Deleted Successfully');
      console.log(data);
    }
  } catch (error) {
    console.log(error);
    toast('Newsletter Not Deleted');
    dispatch({ type: NEWSLETTER_FAILURE });
  }
};
